import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

//Plugins
import createPersistedState from "vuex-persistedstate";

//Modules
import authenticateStore from "./modules/authenticate-store";
import signupStore from "./modules/signup-store";
import userStore from "./modules/user-store";
import routeStore from "./modules/route-store";
import pushNotificationStore from "./modules/push_notification-store";
import homeLoaderStore from "./modules/Loader-store/home_loader-store";
import shopAddressLoaderStore from "./modules/Loader-store/shopAddress_loader-store";
import historicLoaderStore from "./modules/Loader-store/historic_loader-store";
import notificationsLoaderStore from "./modules/Loader-store/notification_loader-store";
import profileLoaderStore from "./modules/Loader-store/profile_loader-store";
import ratingLoaderStore from "./modules/Loader-store/rating_loader.store";
import rewardLoaderStore from "./modules/Loader-store/reward_loader-store";


export default new Vuex.Store({
  modules: {
    authenticateStore,
    signupStore,
    userStore,
    routeStore,
    homeLoaderStore,
    shopAddressLoaderStore,
    historicLoaderStore,
    notificationsLoaderStore,
    profileLoaderStore,
    ratingLoaderStore,
    rewardLoaderStore,
    pushNotificationStore
  },
  plugins: [createPersistedState( {
        paths: [
          'authenticateStore',
          'signupStore',
          'userStore',
          'routeStore',
          'homeLoaderStore',
          'shopAddressLoaderStore',
          'historicLoaderStore',
          'notificationsLoaderStore',
          'profileLoaderStore',
          'ratingLoaderStore',
          'rewardLoaderStore',
          'pushNotificationStore'
        ]
      }
    )
  ],
  mutations: {
    reset_all_state_modules_except_currentCompany(state) {
      state.authenticateStore.currentUser = {}
      state.authenticateStore.token = null

      state.signupStore.signupUser = {}
      state.signupStore.haveAccessToSignup = false

      state.userStore.image = null
    }
  },
  actions: {
    RESET_ALL_STATE_EXCEPT_CURRENT_COMPANY({commit}) {
      commit('reset_all_state_modules_except_currentCompany')
    }
  }
})
